import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 80%;
  margin: auto;

  @media (max-width: 768px) {
    width: 90%;
  }
`
export const BreadCrumbWrapper = styled.div`
  padding: 15px 0 0 30px;
`
export const FaqGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
`
export const Card = styled.div`
  border-radius: 20px;
  border: 1px solid var(--grey-25);
  display: flex;
  flex-direction: column;
  padding: 40px;
  align-items: center;
  text-align: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`

export const Description = styled.div`
  font-size: 14px;
  font-weight: var(--font-regular);
  line-height: 1.5;
  max-width: 200px;
`

export const FaqHeader = styled.div`
  font-size: 28px;
  font-weight: var(--font-bold);

  @media (max-width: 768px) {
    font-size: 22px;
  }
`

export const SupportContainer = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 1200px;
  margin: auto;

  @media (max-width: 1250px) {
    flex-direction: column;
    max-width: unset;
  }
`

export const SupportSectionLeft = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: auto;
`

export const SupportSectionRight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`

export const SupportLabel = styled.text`
  display: flex;
  flex-direction: row;

  svg {
    position: absolute;
    right: -35px;
    top: -35px;
  }

  @media (max-width: 1250px) {
    svg {
      display: none;
    }
  }
`
export const SupportDescription = styled.text`
  font-size: 18px;
  font-weight: var(--font-regular);
  line-height: 160%;
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: auto;

  & > button:first-child {
    margin-right: 20px;
  }

  @media (max-width: 1250px) {
    flex-direction: column;
    & > button:first-child {
      margin: 0 0 10px 0;
    }
  }
`

export const SupportContactContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  @media (max-width: 1250px) {
    width: 100%;
  }
`
export const BlackCard = styled.span`
  width: 460px;
  background: var(--brand-secondary);
  transform: rotate(3deg);
  height: 250px;
  margin-bottom: 16px;
  position: absolute;
  z-index: 1;
  border-radius: 20px;

  @media (max-width: 1250px) {
    display: none;
  }
`
export const YellowCard = styled.div`
  width: 460px;
  background: var(--brand-primary);
  transform: rotate(-3deg);
  height: 250px;
  margin-bottom: 16px;
  position: relative;
  padding: 40px;
  z-index: 1;
  box-sizing: border-box;
  border-radius: 20px;

  @media (max-width: 1250px) {
    transform: unset;
    width: 100%;
    height: auto;
    padding: 30px;
  }
`
export const SupportContact = styled.div`
  display: flex;
  flex-direction: column;
`
export const ContactNumber = styled.span`
  font-size: 14px;
  font-weight: var(--font-regular);
`
export const ContactName = styled.span`
  font-weight: var(--font-medium);
`
